import React from "react";

const ConvertToPreviewLink = ({ driveLink }) => {

  const convertToPreviewLink = (link) => {
   
    const fileIdMatch = link.match(/\/d\/(.*?)\//);
    if (fileIdMatch && fileIdMatch[1]) {
      const fileId = fileIdMatch[1];
      
      return `https://drive.google.com/file/d/${fileId}/preview`;
    }
    return "Link inválido";
  };

  const previewLink = convertToPreviewLink(driveLink);

  return (
    <div>
      {previewLink !== "Link inválido" && (
        <iframe
          src={previewLink}
          width="550"
          height="365"
          allow="autoplay"
          title="Google Drive Preview"
          style={{ border: "none" }}
        ></iframe>
      )}
    </div>
  );
};


const GoogleDriveImage = ({ driveLink }) => {
  if (!driveLink) {
    return <div>Link não fornecido</div>;
  }
  return <ConvertToPreviewLink driveLink={driveLink} />;
};

export default GoogleDriveImage;

